module.exports = __webpack_public_path__ + "img/header.e8b92d13.png";